import type { InputProps } from '@chakra-ui/react';

/** Input of the onboarding forms (mock-up: 50px, radius 12, white on cream). */
export const ONBOARDING_INPUT_PROPS: InputProps = {
  variant: 'outline',
  h: '50px',
  borderRadius: '12px',
  bg: 'white',
  borderColor: 'border.emphasized',
  fontSize: '15px',
  _focusVisible: { borderColor: 'primary.900', outline: 'none' },
};

export const ONBOARDING_LABEL_PROPS = {
  fontFamily: 'heading',
  fontSize: '13px',
  fontWeight: '500',
  color: 'navInactive',
} as const;
